import { withT } from "neetocommons/react-utils";
import { Column } from "neetoicons";
import { omit } from "ramda";

import ManageColumns from "components/Columns";

const unUsedI18nProps = ["tReady", "i18n"];

const Columns = withT(
  ({
    t,
    buttonProps = {},
    columnData,
    onMutationSuccess,
    allowConfigurationResetOnUpdate,
    tableKey,
    ...props
  }) => (
    <div className="neeto-molecules-subheader__columns">
      <ManageColumns
        isSearchable
        className="neeto-ui-dropdown--manage-columns"
        buttonProps={{
          icon: Column,
          label: null,
          tooltipProps: {
            content: t("neetoMolecules.columns.columns"),
            position: "bottom",
            touch: ["hold", 500],
          },
          "data-testid": "columns-dropdown-button",
          ...buttonProps,
        }}
        {...{
          allowConfigurationResetOnUpdate,
          columnData,
          onMutationSuccess,
          tableKey,
          ...omit(unUsedI18nProps, props),
        }}
      />
    </div>
  )
);

Columns.displayName = "Columns";
export default Columns;
